import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CategoryBuilder } from '../../models/builders/category.builder';
import { getErrorHandlingOptions } from '../base/headers';
import { Category } from '../../models/category';
import { CategoryTypeBuilder } from '../../models/builders/category-type.builder';

const categoryBody = (category: Category) => ({
  name: category.name,
  type: category.type
});

@Injectable()
export class CategoryApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }categories`;
  }

  getCategory(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(CategoryBuilder.fromJson)
      );
  }

  getCategories() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(CategoryBuilder.fromList)
      );
  }

  createCategory(category) {
    return this.httpClient.post(this.apiUrl, categoryBody(category)).pipe(map(CategoryBuilder.fromJson));
  }

  updateCategory(category: Category) {
    return this.httpClient.put(`${ this.apiUrl }/${ category.hash }`, categoryBody(category));
  }

  deleteCategory(category: Category) {
    return this.httpClient.delete(`${ this.apiUrl }/${ category.hash }`);
  }

  getCategoryTypes() {
    return this.httpClient.get(`${ this.apiUrl }/types`)
      .pipe(
        map(CategoryTypeBuilder.fromList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/category-api.service.ts